function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 22H5c-1.7 0-3-1.3-3-3V5c0-1.7 1.3-3 3-3h14c1.7 0 3 1.3 3 3v14c0 1.7-1.3 3-3 3zM5 4c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 10H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 22c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1s1 .4 1 1v12c0 .6-.4 1-1 1z"
});

function SvgLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE5LDIySDVjLTEuNywwLTMtMS4zLTMtM1Y1YzAtMS43LDEuMy0zLDMtM2gxNGMxLjcsMCwzLDEuMywzLDN2MTRDMjIsMjAuNywyMC43LDIyLDE5LDIyeiBNNSw0QzQuNCw0LDQsNC40LDQsNXYxNAoJYzAsMC42LDAuNCwxLDEsMWgxNGMwLjYsMCwxLTAuNCwxLTFWNWMwLTAuNi0wLjQtMS0xLTFINXoiLz4KPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMjEsMTBIM2MtMC42LDAtMS0wLjQtMS0xczAuNC0xLDEtMWgxOGMwLjYsMCwxLDAuNCwxLDFTMjEuNiwxMCwyMSwxMHoiLz4KPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNOSwyMmMtMC42LDAtMS0wLjQtMS0xVjljMC0wLjYsMC40LTEsMS0xczEsMC40LDEsMXYxMkMxMCwyMS42LDkuNiwyMiw5LDIyeiIvPgo8L3N2Zz4K";
export { SvgLayout as ReactComponent };